import { put, takeLatest, all, call } from "redux-saga/effects";
import { toast } from "react-toastify";

import { getDashboardFailure, getDashboardSuccess } from "../../actions";
import { GET_DASHBOARD } from "../../Actions/types";
import api from "../../../helper/api";

function* fetchDashboard(action) {
  try {
    const response = yield api.get("dashboard/data-counters");
    
    if (response?.status === 200 && response?.data?.code === 200) {
      yield call(action?.payload?.callback, response.data?.data);
      yield put(getDashboardSuccess({ data: response.data?.data }));
    } else {
      toast.error(response?.data?.message);
    }
  } catch (e) {   
    toast.error(e?.response?.data?.message);
    yield put(getDashboardFailure({ error: e }));
  }
}

function* dashboardWatcher() {
  yield takeLatest(GET_DASHBOARD, fetchDashboard);
}

export default function* dashboardSaga() {
  yield all([dashboardWatcher()]);
}
